"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dumpGtx = dumpGtx;
exports.dumpGtv = dumpGtv;
const buffer_1 = require("buffer");
const __1 = require("../..");
function dumpGtx(gtxTx) {
    var _a;
    return `blockchainRid:\n${__1.formatter.toString(gtxTx.blockchainRid)}\n
operations:
${gtxTx.operations.map(op => ` - ${op.opName}(${op.args.map(dumpGtv).join(", ")})\n`).join("")}
signers:
${gtxTx.signers.map(s => ` - ${__1.formatter.toString(s)}\n`).join("")}
signatures:
${(_a = gtxTx.signatures) === null || _a === void 0 ? void 0 : _a.map(s => ` - ${__1.formatter.toString(s)}\n`).join("")}`;
}
function dumpGtv(rawGtv) {
    return JSON.stringify(rawGtv, (_key, value) => {
        if (typeof value === "bigint") {
            return `${value.toString()}L`;
        }
        if (buffer_1.Buffer.isBuffer(value)) {
            return __1.formatter.toString(value);
        }
        if (typeof value === "object" &&
            value !== null &&
            value.type === "Buffer" &&
            Array.isArray(value.data)) {
            return `0x${value.data}`;
        }
        return value;
    });
}
//# sourceMappingURL=dump.js.map